<section class="dark:text-white">
  <div
    class="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6 flex flex-col items-center"
  >
    <div class="mb-20 flex flex-col items-center text-black dark:text-white" [dir]="languageDirection">
      <h1
        class="mb-4 text-4xl tracking-tight font-extrabold"
      >
        {{ 'FAQ.TITLE' | translate }}
      </h1>
      <p class="max-w-4xl">
        {{ 'FAQ.DESCRIPTION' | translate }}
      </p>
    </div>
    <div [dir]="languageDirection">
      @for (faq of faqData; track $index) {
        <div class="flex flex-col w-full items-start">
          <h1 class="text-2xl text-black dark:text-white">{{ faq.attributes.title | capitalize}}</h1>
          <hr class="h-px mb-8 bg-gray-300 border-0 dark:bg-gray-700 w-full" />
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
          @for (question of faq.attributes.faqs.data; track $index) {
            <div class="mb-10 mx-8">
              <div class="flex flex-row mb-4">
                <div class="flex items-center ltr:pr-4 rtl:pl-4">
                  <ng-icon
                  class="text-black dark:text-white"
                  style="--ng-icon__size: 1.5rem;"
                  name="heroQuestionMarkCircle"
                  ></ng-icon>
                </div>
                <h3 class="flex items-center text-lg font-medium text-gray-900 dark:text-white">
                  {{ question.attributes.question }}
                </h3>
              </div>
              <div [innerHTML]="question.attributes.answer" class="text-gray-500 dark:text-gray-400"></div>
            </div>
          }
        </div>
      }
    </div>

    <div [dir]="languageDirection" class="felx flex-col max-w-md text-xl">
      <div class="my-2 px-2">
        <h1>{{ 'FAQ.QUESTION-NOT-FOUND' | translate }}</h1>
        <h1 class="text-sm">{{ 'FAQ.ASK-YOUR-QUESTION' | translate }}</h1>
      </div>
      @if(succesfullyAskedQuestion | async){
        <div
        class="max-w-md flex items-center p-4 mb-4 text-sm text-green-800 border border-green-300 rounded-lg dark:bg-gray-800 dark:text-green-400 dark:border-green-800"
        role="alert">
          <img
            src="assets/icons/info-green.svg"
            class="flex-shrink-0 inline w-4 h-4 me-3"
            aria-hidden="true"
            alt="Almanjobs logo"
          />
          <div>
            {{ 'FAQ.SUCCESSFULLY-ASKED-QUESTION' | translate }}
          </div>
        </div>
      }
      <form
      [formGroup]="faqForm"
      (ngSubmit)="onFormSubmit()"
      >
        <div
          class="items-center mx-auto mb-3 space-y-4 max-w-screen-sm sm:flex sm:space-y-0 rtl:flex-row-reverse"
        >
          <div class="w-full">
            <label
              for="faqInput"
              class="hidden mb-2 text-sm font-medium dark:text-gray-300"
              >Your Question</label
            >
            <textarea id="faqTextarea"
                      formControlName="question"
                      rows="4"
                      class="block p-2.5 w-full text-sm bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
            </textarea>

          </div>
        </div>
        <div class="flex justify-end rtl:justify-start">
          <button
            type="submit"
            class="py-3 px-5 text-sm font-medium text-center text-white rounded-lg border cursor-pointer bg-blue-700 border-blue-600 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:opacity-50 disabled:cursor-not-allowed"
            [disabled]="succesfullyAskedQuestion | async"
          >
            {{ 'FAQ.ASK-QUESTION' | translate }}
          </button>
        </div>
      </form>

    </div>
  </div>
</section>
